var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showLogin)?_c('div',{attrs:{"id":"app"}},[(_vm.showSide)?_c('div',{staticClass:"sidebar"},[_c('mycard')],1):_vm._e(),_c('div',{staticClass:"main"},[_c('router-view')],1)]):_c('div',{attrs:{"id":"appLogin"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }